import { selectNextRow, selectPreviousRow } from 'owa-mail-actions';
import { onComposeClosed, onComposeOpened } from 'owa-mail-actions/lib/composeActions';
import { onMailSearchComplete } from 'owa-mail-actions/lib/mailSearchActions';
import { lazyRefreshAd } from 'owa-mail-ads';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import selectFocusedViewFilter from 'owa-mail-list-actions/lib/actions/selectFocusedViewFilter';
import { orchestrator } from 'satcheljs';
import { onSelectFolderComplete, onSingleMailItemSelected, } from 'owa-mail-actions/lib/mailListActions';
import { onDeleteConversationItemPartsComplete, toggleRowReadStateComplete, } from 'owa-mail-actions/lib/mailTriageActions';
// setTimeout handler for refresh panel ads task
var refreshAdOnTimeoutTask;
/**
 * Orchestrators listening for various actions to refresh panel ad
 */
orchestrator(onSingleMailItemSelected, function () { return scheduleRefreshTask('onSingleMailItemSelected'); });
orchestrator(onSelectFolderComplete, function () { return scheduleRefreshTask('onSelectFolderComplete'); });
orchestrator(onDeleteConversationItemPartsComplete, function () {
    return scheduleRefreshTask('onDeleteConversationItemPartsCompleted');
});
orchestrator(toggleRowReadStateComplete, function () { return scheduleRefreshTask('toggleRowReadStateComplete'); });
orchestrator(onMailSearchComplete, function () { return scheduleRefreshTask('onMailSearchComplete'); });
orchestrator(onComposeOpened, function () { return scheduleRefreshTask('onComposeOpened'); });
orchestrator(onComposeClosed, function () { return scheduleRefreshTask('onComposeClosed'); });
orchestrator(selectNextRow, function () { return scheduleRefreshTask('selectNextRow'); });
orchestrator(selectPreviousRow, function () { return scheduleRefreshTask('selectPreviousRow'); });
orchestrator(selectFocusedViewFilter, function () { return scheduleRefreshTask('selectFocusedViewFilter'); });
/**
 * Refresh ad scehduler called from all orchestrators
 * @param sourceActionName the name of the source action
 */
function scheduleRefreshTask(sourceActionName) {
    if (refreshAdOnTimeoutTask) {
        // No-op, if there is pending refreshAd task
        return;
    }
    // We want to delay refreshing of the panel ad so that it does not interfere in the
    // synchronous execution of the action requesting the refresh of the ad
    refreshAdOnTimeoutTask = setTimeout(function () {
        refreshAdsInternal(sourceActionName);
    }, 0);
}
/**
 * Makes a call to refresh the panel ad
 * @param sourceActionName the source action
 */
function refreshAdsInternal(sourceActionName) {
    // Only import refreshAd when the user is under the Ads flight, otherwise, the adspanel js will be downloaded to the enterprise account.
    if (isMailFeatureEnabled('fwk-ads')) {
        lazyRefreshAd.import().then(function (refreshAd) {
            refreshAd(sourceActionName);
            refreshAdOnTimeoutTask = null;
        });
    }
}
//# sourceMappingURL=refreshPanelAdsOrchestrators.js.map